import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import GalleryCards from "../../components/gallery-card/galleryCard"
import { useRequestProcessor } from "../../api/requestProcessor"
import { useState } from "react"
import { getAllGalleries } from "../../api/galleries"
import Loading from "../../components/loading/loading"
import { confirmComment, disapproveComment, getAllComments, getAllUnverifiedComments } from "../../api/comments"


import reply from "../../assets/icons/generals/reply.svg"
import Reply from "../../components/modal/reply"
import { toast } from "react-toastify"
import Pagination from "../../components/pagination/pagination"

const CommentsTable = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [modalData, setModalData] = useState()
    const [activeTab, setActiveTab] = useState(0)
    // const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)
    const [unverifiedPage, setUnverifiedPage] = useState(1)

    const { Query, Mutate } = useRequestProcessor()

    const { mutate: mutateConfirm } = Mutate("confirmComment",
        confirmComment,
        {
            onSuccess: (data) => {
                toast.success(data.message)
            },
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    )
    const { mutate: mutateDisaprrove } = Mutate("disapproveComment",
        disapproveComment,
        {
            onSuccess: (data) => {
                toast.success(data.message)
            },
            onError: (data) => {
                toast.error(data.response.data.message)
            }

        }
    )

    const { data, isLoading, isError, refetch } = Query(
        ['getAllUnverifiedComments', page],
        () => getAllComments("", page),
        { enabled: Boolean(page) }
    );
    const { data: unverifiedCommentData, isLoading: isLoadingUnverify, refetch: refetchUnverified } = Query(
        ['getAllComments', page],
        () => getAllUnverifiedComments("", page),
        { enabled: Boolean(unverifiedPage) }
    );


    function onConfirm() {
        setIsModalOpen(false)
        if(activeTab === 0){
            refetch()
        }
        else{
            refetchUnverified()
        }
    }

    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };
    const handleUnverifiedPageClick = (event) => {
        setUnverifiedPage(event.selected + 1);
    };


    return (
        <Layout>
            <MainPageLayout title={"نظرات"} customClass={"min-h-full"}>
                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse">
                    <div className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278]">
                        <button onClick={() => setActiveTab(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        <button onClick={() => setActiveTab(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>کامنت های  در انتظار تایید</button>

                    </div>

                </div>
                {
                    isModalOpen && <Reply data={modalData} onConfirm={onConfirm} />
                }
                <table className="table-auto transition-all" >
                    <thead className="!py-2" >
                        <tr className=" border-b border-black">
                            <th className="py-3">#</th>
                            <th className="py-3">نام کاربر</th>
                            <th className="py-3">نظر</th>
                            <th className="py-3">وضعیت</th>
                            <th className="py-3">پاسخ</th>
                            <th className="py-3">عملیات</th>
                        </tr>
                    </thead>
                    {
                        activeTab === 0 ?
                            !isLoading &&
                            <tbody>
                                {
                                    data?.data?.length ?
                                        data?.data?.map(el => (
                                            <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                <td className="text-center py-5" >{el.id}</td>
                                                <td className="text-center py-5" > {el.name}</td>
                                                <td className="text-center py-5 max-w-[140px]" > {el.comment}</td>
                                                <td className="text-center py-5 " >
                                                    {
                                                        el.approved ?
                                                            <p className="font-bold text-green-500">تایید شده</p>
                                                            :
                                                            <p className="font-bold text-red-500">تایید نشده</p>
                                                    }
                                                </td>
                                                <td className="items-center text-center py-5" >
                                                    <div className="flex justify-center !cursor-pointer" onClick={() => {
                                                        setModalData(el);
                                                        setIsModalOpen(true)
                                                    }}>
                                                        <img src={reply} className="w-5" alt="پاسخ" />
                                                    </div>

                                                </td>
                                                <td className="text-center py-5" >
                                                    <div className="flex justify-evenly items-center">
                                                        <div className=" cursor-pointer text-green-500" onClick={() => { mutateConfirm(el.id) }}>✓</div>
                                                        <div className=" cursor-pointer text-red-500" onClick={() => { mutateDisaprrove(el.id) }}>✗</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <div>
                                            <p>هیچ کامنتی پیدا نشد</p>
                                        </div>
                                }
                            </tbody>
                            :
                            !isLoadingUnverify &&
                            <tbody>
                                {
                                    unverifiedCommentData?.data?.length ?
                                        unverifiedCommentData?.data?.map(el => (
                                            <tr key={el.id} className="text-[#575757] border-b border-[#d5d5d5] hover:bg-[#fafafa]"  >
                                                <td className="text-center py-5" >{el.id}</td>
                                                <td className="text-center py-5" > {el.name}</td>
                                                <td className="text-center py-5 max-w-[140px]" > {el.comment}</td>
                                                <td className="text-center py-5 " >
                                                    {
                                                        el.approved ?
                                                            <p className="font-bold text-green-500">تایید شده</p>
                                                            :
                                                            <p className="font-bold text-red-500">تایید نشده</p>
                                                    }
                                                </td>
                                                <td className="items-center text-center py-5" >
                                                    <div className="flex justify-center !cursor-pointer" onClick={() => {
                                                        setModalData(el);
                                                        setIsModalOpen(true)
                                                    }}>
                                                        <img src={reply} className="w-5" alt="پاسخ" />
                                                    </div>

                                                </td>
                                                <td className="text-center py-5" >
                                                    <div className="flex justify-evenly items-center">
                                                        <div className=" cursor-pointer text-green-500" onClick={() => { mutateConfirm(el.id) }}>✓</div>
                                                        <div className=" cursor-pointer text-red-500" onClick={() => { mutateDisaprrove(el.id) }}>✗</div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <div>
                                            <p>هیچ کامنتی پیدا نشد</p>
                                        </div>
                                }
                            </tbody>
                    }
                </table>
                {
                    isLoading || isLoadingUnverify && <Loading />
                }
                {data?.meta?.last_page > 1 && activeTab == 0 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}
                {unverifiedCommentData?.meta?.last_page > 1 && activeTab == 1 && <Pagination handlePageClick={handleUnverifiedPageClick} lastPage={unverifiedCommentData?.meta?.last_page} />}

            </MainPageLayout>
        </Layout>
    )
}

export default CommentsTable